import { useTimezone } from '@/hooks/useTimezone';
import { Clock } from "lucide-react";
import { cn } from '@/lib/cn';
import { useTranslation } from "react-i18next";

const TIMEZONES = [
  { label: "UTC", value: "UTC" },
  { label: "São Paulo", value: "America/Sao_Paulo" },
  { label: "New York", value: "America/New_York" },
  { label: "Lisbon", value: "Europe/Lisbon" },
  { label: "London", value: "Europe/London" },
  { label: "Madrid", value: "Europe/Madrid" },
  { label: "Tokyo", value: "Asia/Tokyo" },
];

export function TimezoneSelector({ className }: { className?: string }) {
  const { timezone, setTimezone } = useTimezone();
  const { t } = useTranslation("common");
  return (
    <label
      className={cn(
        "inline-flex h-9 items-center gap-1.5 rounded-md border border-border bg-background px-2 text-sm text-muted-foreground",
        className,
      )}
    >
      <Clock className="h-4 w-4" />
      <span className="sr-only">{t("common.timezone")}</span>
      <select
        value={timezone}
        onChange={(e) => setTimezone(e.target.value)}
        className="bg-transparent text-xs font-medium text-foreground outline-none"
        aria-label={t("common.timezone")}
      >
        {TIMEZONES.map((tz) => (
          <option key={tz.value} value={tz.value}>
            {tz.label}
          </option>
        ))}
      </select>
    </label>
  );
}
